module.exports = __webpack_public_path__ + "img/logo_esig_p.5966bc0c.png";